import image from "./sample_img.png";
import {
  ProjectResponse,
  MergedProjectResponse,
} from "../components/impact-map/map-setup-context/InitialMapValues";

export const justOneMockProject: ProjectResponse = {
  id: "64de08434d2c7a00463cfa2a",
  name: "Agroforestry - Smallholder deforestation Farmers, Chiapas and Oaxaca",
  description:
    "Run by our partner Bosques Amazonicos SAC (BAM) this project aims to reduce deforestation in over 300,000 hectares of Peruvian Amazon and reduce millions of Run by our partner Bosques Amazonicos SAC (BAM) this project aims to reduce deforestation in over 300,000 hectares of Peruvian Amazon and reduce millions of Run by our partner Bosques Amazonicos SAC (BAM) this project aims to reduce deforestation in over 300,000 hectares of Peruvian Amazon and reduce millions of",
  country: ["KE"],
  images: { default: "sample_img" },
  SDG: [1, 2, 3, 11, 12, 13, 14],
  websiteUrl: "projects/tist-farmers-kenya",
  centerCoordinates: { lat: 70, lon: 56 },
  zoomLevel: 8,
  outcomes: {
    v2: [
      {
        unit: "m2",
        value: 5,
        isUnitOfSale: false,
        startDate: 0,
        endDate: 1234567891234,
        updatedAt: 1212121212121,
        author: "me@earthly.org",
      },
      {
        unit: "Tonnes CO2",
        value: 12,
        isUnitOfSale: true,
        startDate: 0,
        endDate: 1234567891234,
        updatedAt: 1212121212121,
        author: "me@earthly.org",
      },
    ],
    v3: [
      {
        unit: "m2",
        value: 5,
        isUnitOfSale: false,
        startDate: 0,
        endDate: 1234567891234,
        updatedAt: 1212121212121,
        author: "me@earthly.org",
      },
      {
        unit: "Tonnes CO2",
        value: 12,
        isUnitOfSale: true,
        startDate: 0,
        endDate: 1234567891234,
        updatedAt: 1212121212121,
        author: "me@earthly.org",
      },
    ],
  },
  interventions: [
    {
      action: [],
      ecosystem: ["Forests"],
    },
  ],
  unitData: {
    geometry: {
      type: "FeatureCollection" as const,
      features: [
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-0.032837765318133, 50.888625632769916],
                  [-0.032838914934617, 50.88859833375078],
                  [-0.032881014852961, 50.888599043262325],
                  [-0.032879865261103, 50.88862634228193],
                  [-0.032837765318133, 50.888625632769916],
                ],
              ],
            ],
          },
          properties: {
            whatThreeWordsPoint: "dips.ignore.reviews",
            spatialIndex: 169,
          },
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-0.032795665376872, 50.888624923242695],
                  [-0.032796815017977, 50.88859762422403],
                  [-0.032838914934617, 50.88859833375078],
                  [-0.032837765318133, 50.888625632769916],
                  [-0.032795665376872, 50.888624923242695],
                ],
              ],
            ],
          },
          properties: {
            whatThreeWordsPoint: "songbird.landmark.evidently",
            spatialIndex: 170,
          },
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-0.032753565437314, 50.88862421370029],
                  [-0.032754715103045, 50.888596914682104],
                  [-0.032796815017977, 50.88859762422403],
                  [-0.032795665376872, 50.888624923242695],
                  [-0.032753565437314, 50.88862421370029],
                ],
              ],
            ],
          },
          properties: {
            whatThreeWordsPoint: "lighters.bundles.undertone",
            spatialIndex: 171,
          },
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-0.032711465499468, 50.8886235041427],
                  [-0.032712615189817, 50.888596205125],
                  [-0.032754715103045, 50.888596914682104],
                  [-0.032753565437314, 50.88862421370029],
                  [-0.032711465499468, 50.8886235041427],
                ],
              ],
            ],
          },
          properties: {
            whatThreeWordsPoint: "boomers.pitchers.haggling",
            spatialIndex: 172,
          },
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-0.032669365563324, 50.88862279456992],
                  [-0.032670515278302, 50.888595495552686],
                  [-0.032712615189817, 50.888596205125],
                  [-0.032711465499468, 50.8886235041427],
                  [-0.032669365563324, 50.88862279456992],
                ],
              ],
            ],
          },
          properties: {
            whatThreeWordsPoint: "bikers.clashing.branching",
            spatialIndex: 173,
          },
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-0.032627265628886, 50.88862208498197],
                  [-0.03262841536849, 50.8885947859652],
                  [-0.032670515278302, 50.888595495552686],
                  [-0.032669365563324, 50.88862279456992],
                  [-0.032627265628886, 50.88862208498197],
                ],
              ],
            ],
          },
          properties: {
            whatThreeWordsPoint: "typically.lakeside.angel",
            spatialIndex: 174,
          },
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-0.032585165696156, 50.88862137537881],
                  [-0.032586315460381, 50.888594076362516],
                  [-0.03262841536849, 50.8885947859652],
                  [-0.032627265628886, 50.88862208498197],
                  [-0.032585165696156, 50.88862137537881],
                ],
              ],
            ],
          },
          properties: {
            whatThreeWordsPoint: "typically.lakeside.angel", // w3w?
            spatialIndex: 175,
          },
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-0.032543065765133, 50.88862066576047],
                  [-0.032544215553981, 50.88859336674466],
                  [-0.032586315460381, 50.888594076362516],
                  [-0.032585165696156, 50.88862137537881],
                  [-0.032543065765133, 50.88862066576047],
                ],
              ],
            ],
          },
          properties: {
            whatThreeWordsPoint: "proofread.clinking.pads",
            spatialIndex: 176,
          },
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-0.032500965835815, 50.88861995612695],
                  [-0.032502115649286, 50.88859265711159],
                  [-0.032544215553981, 50.88859336674466],
                  [-0.032543065765133, 50.88862066576047],
                  [-0.032500965835815, 50.88861995612695],
                ],
              ],
            ],
          },
          properties: {
            whatThreeWordsPoint: "audible.december.seducing",
            spatialIndex: 177,
          },
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-0.032458865908205, 50.888619246478214],
                  [-0.0324600157463, 50.88859194746334],
                  [-0.032502115649286, 50.88859265711159],
                  [-0.032500965835815, 50.88861995612695],
                  [-0.032458865908205, 50.888619246478214],
                ],
              ],
            ],
          },
          properties: {
            whatThreeWordsPoint: "frostbite.purchaser.rise",
            spatialIndex: 178,
          },
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-0.032416765982298, 50.88861853681433],
                  [-0.032417915845017, 50.88859123779991],
                  [-0.0324600157463, 50.88859194746334],
                  [-0.032458865908205, 50.888619246478214],
                  [-0.032416765982298, 50.88861853681433],
                ],
              ],
            ],
          },
          properties: {
            whatThreeWordsPoint: "kingdom.believer.arise",
            spatialIndex: 179,
          },
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-0.0323746660581, 50.88861782713523],
                  [-0.032375815945443, 50.8885905281213],
                  [-0.032417915845017, 50.88859123779991],
                  [-0.032416765982298, 50.88861853681433],
                  [-0.0323746660581, 50.88861782713523],
                ],
              ],
            ],
          },
          properties: {
            whatThreeWordsPoint: "skillet.microfilm.otherwise",
            spatialIndex: 180,
          },
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-0.032332566135612, 50.88861711744095],
                  [-0.032333716047577, 50.88858981842748],
                  [-0.032375815945443, 50.8885905281213],
                  [-0.0323746660581, 50.88861782713523],
                  [-0.032332566135612, 50.88861711744095],
                ],
              ],
            ],
          },
          properties: {
            whatThreeWordsPoint: "tunes.gratitude.surprises",
            spatialIndex: 181,
          },
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-0.032290466214826, 50.8886164077315],
                  [-0.032291616151418, 50.888589108718485],
                  [-0.032333716047577, 50.88858981842748],
                  [-0.032332566135612, 50.88861711744095],
                  [-0.032290466214826, 50.8886164077315],
                ],
              ],
            ],
          },
          properties: {
            whatThreeWordsPoint: "intruding.equipping.honestly",
            spatialIndex: 182,
          },
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-0.032248366295751, 50.888615698006824],
                  [-0.032249516256967, 50.8885883989943],
                  [-0.032291616151418, 50.888589108718485],
                  [-0.032290466214826, 50.8886164077315],
                  [-0.032248366295751, 50.888615698006824],
                ],
              ],
            ],
          },
          properties: {
            whatThreeWordsPoint: "trading.lightens.contracting",
            spatialIndex: 183,
          },
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-0.032206266378381, 50.88861498826698],
                  [-0.032207416364218, 50.88858768925492],
                  [-0.032249516256967, 50.8885883989943],
                  [-0.032248366295751, 50.888615698006824],
                  [-0.032206266378381, 50.88861498826698],
                ],
              ],
            ],
          },
          properties: {
            whatThreeWordsPoint: "playroom.ignoring.mixing",
            spatialIndex: 184,
          },
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-0.032165226479373, 50.88858697798317],
                  [-0.032164076468861, 50.88861427699475],
                  [-0.032128333707543, 50.888613674401874],
                  [-0.03212773488149, 50.88860670104244],
                  [-0.032114533979167, 50.8885861233471],
                  [-0.032165226479373, 50.88858697798317],
                ],
              ],
            ],
          },
          properties: {
            whatThreeWordsPoint: "printout.speeding.rooftop",
            spatialIndex: 185,
          },
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-0.032164076468861, 50.88861427699475],
                  [-0.032165226479373, 50.88858697798317],
                  [-0.032207416364218, 50.88858768925492],
                  [-0.032206266378381, 50.88861498826698],
                  [-0.032164076468861, 50.88861427699475],
                ],
              ],
            ],
          },
          properties: {
            whatThreeWordsPoint: "steroids.plantings.dandelions",
            spatialIndex: 186,
          },
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-0.032987376541632, 50.888600835712204],
                  [-0.032988529102879, 50.88857346465418],
                  [-0.033042067806379, 50.88857436687308],
                  [-0.033018654919165, 50.8886013628095],
                  [-0.032987376541632, 50.888600835712204],
                ],
              ],
            ],
          },
          properties: {
            whatThreeWordsPoint: "hammocks.chip.rating",
            spatialIndex: 187,
          },
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-0.03294538742056, 50.88860012810629],
                  [-0.03294654000643, 50.888572757048735],
                  [-0.032988529102879, 50.88857346465418],
                  [-0.032987376541632, 50.888600835712204],
                  [-0.03294538742056, 50.88860012810629],
                ],
              ],
            ],
          },
          properties: {
            whatThreeWordsPoint: "ample.outermost.earlobes",
            spatialIndex: 188,
          },
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-0.032903398301187, 50.88859942048526],
                  [-0.03290455091168, 50.88857204942817],
                  [-0.03294654000643, 50.888572757048735],
                  [-0.03294538742056, 50.88860012810629],
                  [-0.032903398301187, 50.88859942048526],
                ],
              ],
            ],
          },
          properties: {
            whatThreeWordsPoint: "settled.lushly.lizards",
            spatialIndex: 189,
          },
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-0.032861409183513, 50.88859871284912],
                  [-0.032862561818627, 50.88857134179252],
                  [-0.03290455091168, 50.88857204942817],
                  [-0.032903398301187, 50.88859942048526],
                  [-0.032861409183513, 50.88859871284912],
                ],
              ],
            ],
          },
          properties: {
            whatThreeWordsPoint: "subtitle.fruitcake.dared",
            spatialIndex: 190,
          },
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-0.032819420067534, 50.88859800519788],
                  [-0.032820572727273, 50.88857063414173],
                  [-0.032862561818627, 50.88857134179252],
                  [-0.032861409183513, 50.88859871284912],
                  [-0.032819420067534, 50.88859800519788],
                ],
              ],
            ],
          },
          properties: {
            whatThreeWordsPoint: "mixer.roadshow.pricier",
            spatialIndex: 191,
          },
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-0.032777430953254, 50.88859729753153],
                  [-0.032778583637619, 50.88856992647585],
                  [-0.032820572727273, 50.88857063414173],
                  [-0.032819420067534, 50.88859800519788],
                  [-0.032777430953254, 50.88859729753153],
                ],
              ],
            ],
          },
          properties: {
            whatThreeWordsPoint: "fraction.stuck.cherubs",
            spatialIndex: 192,
          },
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-0.032735161266741, 50.88859658512125],
                  [-0.032736313975895, 50.88856921406604],
                  [-0.032778583637619, 50.88856992647585],
                  [-0.032777430953254, 50.88859729753153],
                  [-0.032735161266741, 50.88859658512125],
                ],
              ],
            ],
          },
          properties: {
            whatThreeWordsPoint: "calculating.candidate.unafraid",
            spatialIndex: 193,
          },
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-0.032693172155867, 50.88859587742457],
                  [-0.032694324889644, 50.88856850636985],
                  [-0.032736313975895, 50.88856921406604],
                  [-0.032735161266741, 50.88859658512125],
                  [-0.032693172155867, 50.88859587742457],
                ],
              ],
            ],
          },
          properties: {
            whatThreeWordsPoint: "lemmings.sweetened.crunch",
            spatialIndex: 194,
          },
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-0.032651183046691, 50.88859516971279],
                  [-0.032652335805088, 50.888567798658556],
                  [-0.032694324889644, 50.88856850636985],
                  [-0.032693172155867, 50.88859587742457],
                  [-0.032651183046691, 50.88859516971279],
                ],
              ],
            ],
          },
          properties: {
            whatThreeWordsPoint: "introduce.mull.scooped",
            spatialIndex: 195,
          },
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-0.03260919393921, 50.88859446198591],
                  [-0.032610346722234, 50.88856709093213],
                  [-0.032652335805088, 50.888567798658556],
                  [-0.032651183046691, 50.88859516971279],
                  [-0.03260919393921, 50.88859446198591],
                ],
              ],
            ],
          },
          properties: {
            whatThreeWordsPoint: "wing.iteration.shunning",
            spatialIndex: 196,
          },
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-0.032567204833426, 50.88859375424392],
                  [-0.032568357641072, 50.888566383190614],
                  [-0.032610346722234, 50.88856709093213],
                  [-0.03260919393921, 50.88859446198591],
                  [-0.032567204833426, 50.88859375424392],
                ],
              ],
            ],
          },
          properties: {
            whatThreeWordsPoint: "dishing.engaging.wheat",
            spatialIndex: 197,
          },
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-0.032525215729342, 50.88859304648681],
                  [-0.032526368561612, 50.88856567543397],
                  [-0.032568357641072, 50.888566383190614],
                  [-0.032567204833426, 50.88859375424392],
                  [-0.032525215729342, 50.88859304648681],
                ],
              ],
            ],
          },
          properties: {
            whatThreeWordsPoint: "loitering.sideboard.bribing",
            spatialIndex: 198,
          },
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-0.032483226626953, 50.8885923387146],
                  [-0.032484379483848, 50.888564967662234],
                  [-0.032526368561612, 50.88856567543397],
                  [-0.032525215729342, 50.88859304648681],
                  [-0.032483226626953, 50.8885923387146],
                ],
              ],
            ],
          },
          properties: {
            whatThreeWordsPoint: "brisk.refusals.broth",
            spatialIndex: 199,
          },
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-0.032441237526266, 50.88859163092727],
                  [-0.032442390407783, 50.88856425987538],
                  [-0.032484379483848, 50.888564967662234],
                  [-0.032483226626953, 50.8885923387146],
                  [-0.032441237526266, 50.88859163092727],
                ],
              ],
            ],
          },
          properties: {
            whatThreeWordsPoint: "purchaser.achieving.titles",
            spatialIndex: 200,
          },
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-0.032399248427273, 50.88859092312486],
                  [-0.032400401333415, 50.888563552073435],
                  [-0.032442390407783, 50.88856425987538],
                  [-0.032441237526266, 50.88859163092727],
                  [-0.032399248427273, 50.88859092312486],
                ],
              ],
            ],
          },
          properties: {
            whatThreeWordsPoint: "inner.foggy.routines",
            spatialIndex: 201,
          },
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-0.032357259329978, 50.88859021530733],
                  [-0.032358412260743, 50.88856284425638],
                  [-0.032400401333415, 50.888563552073435],
                  [-0.032399248427273, 50.88859092312486],
                  [-0.032357259329978, 50.88859021530733],
                ],
              ],
            ],
          },
          properties: {
            whatThreeWordsPoint: "chuckle.figure.tucked",
            spatialIndex: 202,
          },
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-0.032315270234381, 50.88858950747468],
                  [-0.032316423189771, 50.88856213642421],
                  [-0.032358412260743, 50.88856284425638],
                  [-0.032357259329978, 50.88859021530733],
                  [-0.032315270234381, 50.88858950747468],
                ],
              ],
            ],
          },
          properties: {
            whatThreeWordsPoint: "butlers.obligated.drivers",
            spatialIndex: 203,
          },
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-0.032273281140485, 50.88858879962693],
                  [-0.032274434120494, 50.88856142857693],
                  [-0.032316423189771, 50.88856213642421],
                  [-0.032315270234381, 50.88858950747468],
                  [-0.032273281140485, 50.88858879962693],
                ],
              ],
            ],
          },
          properties: {
            whatThreeWordsPoint: "packets.playback.solves",
            spatialIndex: 204,
          },
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-0.032231292048283, 50.88858809176408],
                  [-0.032232445052919, 50.88856072071453],
                  [-0.032274434120494, 50.88856142857693],
                  [-0.032273281140485, 50.88858879962693],
                  [-0.032231292048283, 50.88858809176408],
                ],
              ],
            ],
          },
          properties: {
            whatThreeWordsPoint: "plod.fixated.chins",
            spatialIndex: 205,
          },
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-0.032189302957779, 50.888587383886104],
                  [-0.032190455987039, 50.88856001283705],
                  [-0.032232445052919, 50.88856072071453],
                  [-0.032231292048283, 50.88858809176408],
                  [-0.032189302957779, 50.888587383886104],
                ],
              ],
            ],
          },
          properties: {
            whatThreeWordsPoint: "haystack.rested.chat",
            spatialIndex: 206,
          },
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-0.032147473410349, 50.88858667868276],
                  [-0.032148626464139, 50.88855930763416],
                  [-0.032190455987039, 50.88856001283705],
                  [-0.032189302957779, 50.888587383886104],
                  [-0.032147473410349, 50.88858667868276],
                ],
              ],
            ],
          },
          properties: {
            whatThreeWordsPoint: "streetcar.ditched.brimmed",
            spatialIndex: 207,
          },
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-0.032148626464139, 50.88855930763416],
                  [-0.032147473410349, 50.88858667868276],
                  [-0.032114533979167, 50.8885861233471],
                  [-0.032103151814922, 50.88856838070287],
                  [-0.032103071804927, 50.88856842897477],
                  [-0.032103055762678, 50.888568230975494],
                  [-0.032103012628359, 50.888568163737226],
                  [-0.032103048582005, 50.88856814234906],
                  [-0.032102269455407, 50.88855852608497],
                  [-0.032148626464139, 50.88855930763416],
                ],
              ],
            ],
          },
          properties: {
            whatThreeWordsPoint: "rapid.solutions.depending",
            spatialIndex: 208,
          },
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-0.033009581835713, 50.888573819431734],
                  [-0.03301069991998, 50.888547266808295],
                  [-0.033064780587574, 50.88854817815024],
                  [-0.033042067806379, 50.88857436687308],
                  [-0.033009581835713, 50.888573819431734],
                ],
              ],
            ],
          },
          properties: {
            whatThreeWordsPoint: "aboard.prepare.waxes",
            spatialIndex: 209,
          },
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-0.032966298503057, 50.88857309002326],
                  [-0.032967416611948, 50.888546537400266],
                  [-0.03301069991998, 50.888547266808295],
                  [-0.033009581835713, 50.888573819431734],
                  [-0.032966298503057, 50.88857309002326],
                ],
              ],
            ],
          },
          properties: {
            whatThreeWordsPoint: "second.crusher.confronts",
            spatialIndex: 210,
          },
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-0.032923015172207, 50.8885723605987],
                  [-0.03292413330572, 50.88854580797619],
                  [-0.032967416611948, 50.888546537400266],
                  [-0.032966298503057, 50.88857309002326],
                  [-0.032923015172207, 50.8885723605987],
                ],
              ],
            ],
          },
          properties: {
            whatThreeWordsPoint: "regress.comic.juggles",
            spatialIndex: 211,
          },
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-0.032879731843155, 50.88857163115811],
                  [-0.032880850001295, 50.88854507853607],
                  [-0.03292413330572, 50.88854580797619],
                  [-0.032923015172207, 50.8885723605987],
                  [-0.032879731843155, 50.88857163115811],
                ],
              ],
            ],
          },
          properties: {
            whatThreeWordsPoint: "doormat.resonates.suspends",
            spatialIndex: 212,
          },
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-0.032836448515911, 50.88857090170145],
                  [-0.032837566698674, 50.888544349079886],
                  [-0.032880850001295, 50.88854507853607],
                  [-0.032879731843155, 50.88857163115811],
                  [-0.032836448515911, 50.88857090170145],
                ],
              ],
            ],
          },
          properties: {
            whatThreeWordsPoint: "last.innovate.clauses",
            spatialIndex: 213,
          },
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-0.03279316519047, 50.88857017222873],
                  [-0.032794283397858, 50.88854361960764],
                  [-0.032837566698674, 50.888544349079886],
                  [-0.032836448515911, 50.88857090170145],
                  [-0.03279316519047, 50.88857017222873],
                ],
              ],
            ],
          },
          properties: {
            whatThreeWordsPoint: "campsites.boosted.limiting",
            spatialIndex: 214,
          },
        },
      ],
    },
    unitCount: 5,
    clientUnitTotalArea: 45,
  },
};
export const mockProjectWithMultipleCountries: ProjectResponse = {
  id: "64de08434d2c7a00463cfa2f",
  name: "Multi-Country Conservation Project",
  description:
    "A cross-border conservation project spanning multiple countries in Latin America",
  country: ["MX", "ES"],
  images: { default: "sample_img" },
  SDG: [1, 2, 3, 11, 12, 13, 14],
  websiteUrl: "projects/multi-country-project",
  centerCoordinates: { lat: 23, lon: -102 },
  zoomLevel: 4,
  outcomes: {
    v2: [
      {
        unit: "m2",
        value: 5,
        isUnitOfSale: false,
        startDate: 0,
        endDate: 1234567891234,
        updatedAt: 1212121212121,
        author: "me@earthly.org",
      },
      {
        unit: "Tonnes CO2",
        value: 12,
        isUnitOfSale: true,
        startDate: 0,
        endDate: 1234567891234,
        updatedAt: 1212121212121,
        author: "me@earthly.org",
      },
    ],
    v3: [
      {
        unit: "m2",
        value: 5,
        isUnitOfSale: false,
        startDate: 0,
        endDate: 1234567891234,
        updatedAt: 1212121212121,
        author: "me@earthly.org",
      },
      {
        unit: "Tonnes CO2",
        value: 12,
        isUnitOfSale: true,
        startDate: 0,
        endDate: 1234567891234,
        updatedAt: 1212121212121,
        author: "me@earthly.org",
      },
    ],
  },
  interventions: [
    {
      action: [],
      ecosystem: ["Forests"],
    },
  ],
};

export const justOneMockProjectWithImpact: MergedProjectResponse = {
  id: "64de08434d2c7a00463cfa2a",
  name: "Agroforestry - Smallholder deforestation Farmers, Chiapas and Oaxaca",
  description:
    "Run by our partner Bosques Amazonicos SAC (BAM) this project aims to reduce deforestation in over 300,000 hectares of Peruvian Amazon and reduce millions of Run by our partner Bosques Amazonicos SAC (BAM) this project aims to reduce deforestation in over 300,000 hectares of Peruvian Amazon and reduce millions of Run by our partner Bosques Amazonicos SAC (BAM) this project aims to reduce deforestation in over 300,000 hectares of Peruvian Amazon and reduce millions of",
  country: ["KE"],
  images: { default: "sample_img" },
  SDG: [1, 2, 3, 11, 12, 13, 14],
  websiteUrl: "projects/tist-farmers-kenya",
  centerCoordinates: { lat: 70, lon: 56 },
  zoomLevel: 8,
  outcomes: {
    v2: [
      {
        unit: "m2",
        value: 5,
        isUnitOfSale: false,
        startDate: 0,
        endDate: 1234567891234,
        updatedAt: 1212121212121,
        author: "me@earthly.org",
      },
      {
        unit: "Tonnes CO2",
        value: 12,
        isUnitOfSale: true,
        startDate: 0,
        endDate: 1234567891234,
        updatedAt: 1212121212121,
        author: "me@earthly.org",
      },
    ],
    v3: [
      {
        unit: "m2",
        value: 5,
        isUnitOfSale: false,
        startDate: 0,
        endDate: 1234567891234,
        updatedAt: 1212121212121,
        author: "me@earthly.org",
      },
      {
        unit: "Tonnes CO2",
        value: 12,
        isUnitOfSale: true,
        startDate: 0,
        endDate: 1234567891234,
        updatedAt: 1212121212121,
        author: "me@earthly.org",
      },
    ],
  },
  interventions: [
    {
      action: [],
      ecosystem: ["Forests"],
    },
  ],
  unitData: {
    geometry: {
      type: "FeatureCollection" as const,
      features: [
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-0.137756438319049, 50.814927894416378],
                  [-0.136382314482885, 50.814927894416378],
                  [-0.136405441694762, 50.814742875519478],
                  [-0.13676175465544, 50.814518530322019],
                  [-0.13748083097923, 50.81455739931279],
                  [-0.137771308044028, 50.814822056177405],
                  [-0.137756438319049, 50.814927894416378],
                ],
              ],
            ],
          },
          properties: {
            whatThreeWordsPoint: "avocado.toast.banana",
          },
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-0.137026600228943, 50.815596878753063],
                  [-0.137026600228943, 50.814927894416378],
                  [-0.137756438319049, 50.814927894416378],
                  [-0.137662448701377, 50.815596878753063],
                  [-0.137026600228943, 50.815596878753063],
                ],
              ],
            ],
          },
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-0.137026600228943, 50.814927894416378],
                  [-0.137026600228943, 50.815596878753063],
                  [-0.136368662387931, 50.815596878753063],
                  [-0.136306465872351, 50.815534682098765],
                  [-0.136382314482885, 50.814927894416378],
                  [-0.137026600228943, 50.814927894416378],
                ],
              ],
            ],
          },
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-0.137088763831327, 50.816578870167035],
                  [-0.136588472927237, 50.816578870167035],
                  [-0.136596794951422, 50.816517841934697],
                  [-0.136807943372565, 50.816220914467451],
                  [-0.136840935313368, 50.815838207954144],
                  [-0.13657699978694, 50.815805216013359],
                  [-0.136368662387931, 50.815596878753063],
                  [-0.137662448701377, 50.815596878753063],
                  [-0.137659135445296, 50.815620461144846],
                  [-0.137316019260939, 50.815864601506767],
                  [-0.13704548534635, 50.81583160956599],
                  [-0.136992698241065, 50.816194520914827],
                  [-0.137098272451636, 50.816498046770221],
                  [-0.137088763831327, 50.816578870167035],
                ],
              ],
            ],
          },
        },
        {
          type: "Feature",
          geometry: {
            type: "MultiPolygon",
            coordinates: [
              [
                [
                  [-0.136588472927237, 50.816578870167035],
                  [-0.137088763831327, 50.816578870167035],
                  [-0.137071878898993, 50.81672239196768],
                  [-0.13685413208969, 50.817006122658597],
                  [-0.136774951431761, 50.817665961474674],
                  [-0.136840935313368, 50.81781772440236],
                  [-0.136794746596243, 50.818174037363036],
                  [-0.136418638471083, 50.818147643810406],
                  [-0.13648462235269, 50.817784732461547],
                  [-0.13657699978694, 50.817659363086499],
                  [-0.136682573997511, 50.816986327494106],
                  [-0.13657699978694, 50.816663006474244],
                  [-0.136588472927237, 50.816578870167035],
                ],
              ],
            ],
          },
        },
      ],
    },
    unitCount: 5,
    clientUnitTotalArea: 45,
  },
  mainImpact: [
    {
      unit: "m3 Kelp",
      value: 475,
    },
    {
      unit: "Tree(s)",
      value: 10,
    },
    {
      unit: "Minutes of monitoring footage",
      value: 500,
    },
  ],
  coBenefits: [
    {
      unit: "Hours of Education",
      value: 1,
    },
    {
      unit: "Hours of Employment",
      value: 8.75,
    },
  ],
  projectId: "64de08434d2c7a00463cfa2a",
};

const mockProjects: ProjectResponse[] = [
  {
    id: "64de08434d2c7a00463cfa2b",
    name: "Aha a biodiversity project!",
    description:
      "Run by our partner Bosques Amazonicos SAC (BAM) this project aims to reduce deforestation in over 300,000 hectares of Peruvian Amazon and reduce millions of Run by our partner Bosques Amazonicos SAC (BAM) this project aims to reduce deforestation in over 300,000 hectares of Peruvian Amazon and reduce millions of Run by our partner Bosques Amazonicos SAC (BAM) this project aims to reduce deforestation in over 300,000 hectares of Peruvian Amazon and reduce millions of",
    country: ["KE"],
    images: { default: "sample_img" },
    SDG: [1, 2, 3, 11, 12, 13, 14],
    websiteUrl: "projects/tist-farmers-kenya",
    centerCoordinates: { lat: 70, lon: 56 },
    zoomLevel: 8,
    outcomes: {
      v2: [
        {
          unit: "m2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "Biodiversity",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
      v3: [
        {
          unit: "m2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "Biodiversity",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
    },
    interventions: [
      {
        action: [],
        ecosystem: ["Coastal"],
      },
    ],
    unitData: {
      geometry: {
        type: "FeatureCollection",
        features: [
          {
            type: "Feature",
            geometry: {
              type: "MultiPolygon",
              coordinates: [
                [
                  [
                    [55.9, 69.9],
                    [55.9, 70.1],
                    [56.1, 70.1],
                    [56.1, 69.9],
                    [55.9, 69.9],
                  ],
                ],
              ],
            },
            properties: {
              whatThreeWordsPoint: "avocado.toast.banana",
            },
          },
        ],
      },
      unitCount: 1,
      clientUnitTotalArea: 9,
    },
  },
  {
    id: "64de08434d2c7a00463cfa2k",
    name: "A few units biodiversity project!",
    description: "12 whole units fam",
    country: ["GB"],
    images: { default: "sample_img" },
    SDG: [1, 2, 3, 11, 12, 13, 14],
    websiteUrl: "projects/bunch-of-units",
    centerCoordinates: {
      lat: 50.884225,
      lon: -0.0344461,
    },
    zoomLevel: 8,
    outcomes: {
      v2: [
        {
          unit: "m2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "Biodiversity",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
      v3: [
        {
          unit: "m2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "Biodiversity",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
    },
    interventions: [
      {
        action: [],
        ecosystem: ["Marine"],
      },
    ],
    unitData: {
      geometry: {
        type: "FeatureCollection",
        features: [
          {
            type: "Feature",
            geometry: {
              type: "MultiPolygon",
              coordinates: [
                [
                  [
                    [-0.03444616494333, 50.884225698532838],
                    [-0.034447178849234, 50.884201598564488],
                    [-0.03449402878579, 50.884200350947914],
                    [-0.034490971089748, 50.88422645309528],
                    [-0.03444616494333, 50.884225698532838],
                  ],
                ],
              ],
            },
            properties: {
              whatThreeWordsPoint: "avocado.toast.banana",
            },
          },
          {
            type: "Feature",
            geometry: {
              type: "MultiPolygon",
              coordinates: [
                [
                  [
                    [-0.034395652417798, 50.884224847850902],
                    [-0.034396573864228, 50.884202946157011],
                    [-0.034447178849234, 50.884201598564488],
                    [-0.03444616494333, 50.884225698532838],
                    [-0.034395652417798, 50.884224847850902],
                  ],
                ],
              ],
            },
            properties: {
              whatThreeWordsPoint: "grape.water.green",
            },
          },
          {
            type: "Feature",
            geometry: {
              type: "MultiPolygon",
              coordinates: [
                [
                  [
                    [-0.03433635497341, 50.884223849194072],
                    [-0.03433704003498, 50.884207566583875],
                    [-0.034378171484802, 50.884203436200281],
                    [-0.034396573864228, 50.884202946157011],
                    [-0.034395652417798, 50.884224847850902],
                    [-0.03433635497341, 50.884223849194072],
                  ],
                ],
              ],
            },
          },
          {
            type: "Feature",
            geometry: {
              type: "MultiPolygon",
              coordinates: [
                [
                  [
                    [-0.03433704003498, 50.884207566583875],
                    [-0.03433635497341, 50.884223849194072],
                    [-0.034198083351996, 50.884221520377828],
                    [-0.03433704003498, 50.884207566583875],
                  ],
                ],
              ],
            },
            properties: {
              whatThreeWordsPoint: "fish.sea.ocean",
            },
          },
          {
            type: "Feature",
            geometry: {
              type: "MultiPolygon",
              coordinates: [
                [
                  [
                    [-0.034448053526201, 50.884253723734034],
                    [-0.034449230397973, 50.884225750157491],
                    [-0.034490971089748, 50.88422645309528],
                    [-0.034487698298436, 50.884254391375727],
                    [-0.034448053526201, 50.884253723734034],
                  ],
                ],
              ],
            },
          },
          {
            type: "Feature",
            geometry: {
              type: "MultiPolygon",
              coordinates: [
                [
                  [
                    [-0.034406972542808, 50.884253031891483],
                    [-0.0344081494392, 50.884225058315387],
                    [-0.034449230397973, 50.884225750157491],
                    [-0.034448053526201, 50.884253723734034],
                    [-0.034406972542808, 50.884253031891483],
                  ],
                ],
              ],
            },
            properties: {
              whatThreeWordsPoint: "cupboard.chair.oval",
            },
          },
          {
            type: "Feature",
            geometry: {
              type: "MultiPolygon",
              coordinates: [
                [
                  [
                    [-0.034365891561038, 50.88425234003445],
                    [-0.034367068482047, 50.884224366458824],
                    [-0.0344081494392, 50.884225058315387],
                    [-0.034406972542808, 50.884253031891483],
                    [-0.034365891561038, 50.88425234003445],
                  ],
                ],
              ],
            },
          },
          {
            type: "Feature",
            geometry: {
              type: "MultiPolygon",
              coordinates: [
                [
                  [
                    [-0.034324810580892, 50.884251648162952],
                    [-0.034325987526518, 50.884223674587801],
                    [-0.034367068482047, 50.884224366458824],
                    [-0.034365891561038, 50.88425234003445],
                    [-0.034324810580892, 50.884251648162952],
                  ],
                ],
              ],
            },
            properties: {
              whatThreeWordsPoint: "bish.bash.bosh",
            },
          },
          {
            type: "Feature",
            geometry: {
              type: "MultiPolygon",
              coordinates: [
                [
                  [
                    [-0.034283729602368, 50.884250956276993],
                    [-0.034284906572612, 50.884222982702305],
                    [-0.034325987526518, 50.884223674587801],
                    [-0.034324810580892, 50.884251648162952],
                    [-0.034283729602368, 50.884250956276993],
                  ],
                ],
              ],
            },
          },
          {
            type: "Feature",
            geometry: {
              type: "MultiPolygon",
              coordinates: [
                [
                  [
                    [-0.034242648625468, 50.884250264376576],
                    [-0.03424382562033, 50.88422229080237],
                    [-0.034284906572612, 50.884222982702305],
                    [-0.034283729602368, 50.884250956276993],
                    [-0.034242648625468, 50.884250264376576],
                  ],
                ],
              ],
            },
            properties: {
              whatThreeWordsPoint: "hes.behind.you",
            },
          },
          {
            type: "Feature",
            geometry: {
              type: "MultiPolygon",
              coordinates: [
                [
                  [
                    [-0.034201589814824, 50.884249572835003],
                    [-0.034202766834291, 50.884221599261259],
                    [-0.03424382562033, 50.88422229080237],
                    [-0.034242648625468, 50.884250264376576],
                    [-0.034201589814824, 50.884249572835003],
                  ],
                ],
              ],
            },
          },
          {
            type: "Feature",
            geometry: {
              type: "MultiPolygon",
              coordinates: [
                [
                  [
                    [-0.034157202872226, 50.884248825222393],
                    [-0.034158183191156, 50.884225527052081],
                    [-0.034198083351996, 50.884221520377828],
                    [-0.034202766834291, 50.884221599261259],
                    [-0.034201589814824, 50.884249572835003],
                    [-0.034157202872226, 50.884248825222393],
                  ],
                ],
              ],
            },
            properties: {
              whatThreeWordsPoint: "super.duper.gang",
            },
          },
        ],
      },
      unitCount: 12,
      clientUnitTotalArea: 108,
    },
  },
  {
    id: "64de08434d2c7a00463cfa9b",
    name: "Aha another biodiversity project!",
    description: "Biodiversity fake projecto",
    country: ["KE"],
    images: { default: image },
    SDG: [1, 2, 3, 11, 12, 13, 14],
    websiteUrl: "projects/tist-farmers-kenya",
    centerCoordinates: { lat: -36.225866, lon: -66.288542 },
    zoomLevel: 8,
    outcomes: {
      v2: [
        {
          unit: "m2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "Biodiversity",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
      v3: [
        {
          unit: "m2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "Biodiversity",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
    },
    interventions: [
      {
        action: [],
        ecosystem: ["Peatland"],
      },
    ],
    unitData: {
      geometry: {
        type: "FeatureCollection",
        features: [
          {
            type: "Feature",
            geometry: {
              type: "MultiPolygon",
              coordinates: [
                [
                  [
                    [-66.298, -36.215],
                    [-66.278, -36.215],
                    [-66.278, -36.235],
                    [-66.298, -36.235],
                    [-66.298, -36.215],
                  ],
                ],
              ],
            },
          },
        ],
      },
      unitCount: 1,
      clientUnitTotalArea: 9,
    },
  },
  {
    id: "64de08434d2c7a00463cfa2c",
    name: "A WRONG coordinates Test",
    description: "just goes to earthly HQ, and doesn't have any SDGs :( ",
    country: ["GB"],
    images: { default: image },
    websiteUrl: "projects/tist-farmers-kenya",
    centerCoordinates: { lat: -92.25528, lon: 16.2586 },
    zoomLevel: 4,
    outcomes: {
      v2: [
        {
          unit: "m2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "Biodiversity",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
      v3: [
        {
          unit: "m2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "Biodiversity",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
    },
    interventions: [
      {
        action: [],
        ecosystem: ["Grassland"],
      },
    ],
  },
  {
    id: "64de08434d2c7a00463cfa2a",
    name: "Agroforestry - Smallholder deforestationdeforestationdeforestation Farmers, Chiapas and Oaxaca.",
    description:
      "Run by our partner Bosques Amazonicos SAC (BAM) this project aims to reduce deforestation in over 300,000 hectares of Peruvian Amazon and reduce millions of Run by our partner Bosques Amazonicos SAC (BAM) this project aims to reduce deforestation in over 300,000 hectares of Peruvian Amazon and reduce millions of Run by our partner Bosques Amazonicos SAC (BAM) this project aims to reduce deforestation in over 300,000 hectares of Peruvian Amazon and reduce millions of",
    country: ["KE"],
    images: { default: image },
    SDG: [1, 2, 3, 11, 12, 13, 14],
    websiteUrl: "projects/tist-farmers-kenya",
    centerCoordinates: { lat: 16.2586, lon: -92.25528 },
    zoomLevel: 4,
    outcomes: {
      v2: [
        {
          unit: "m2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "Tonnes CO2",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
      v3: [
        {
          unit: "m2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "Tonnes CO2",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
    },
    interventions: [
      {
        action: [],
        ecosystem: ["Farmland"],
      },
    ],
  },
  {
    id: "64650c6bdd15c50018d3848e",
    name: "Agroforestry- TIST Kenya",
    description:
      "A chance to support local farmers in Kenya at the beginning of their tree planting journey under the TIST program.A chance to support local farmers in Kenya at the beginning of their tree planting journey under the TIST program.A chance to support local farmers in Kenya at the beginning of their tree planting journey under the TIST program.A chance to support local farmers in Kenya at the beginning of their tree planting journey under the TIST program.A chance to support local farmers in Kenya at the beginning of their tree planting journey under the TIST program.A chance to support local farmers in Kenya at the beginning of their tree planting journey under the TIST program.",
    country: ["GB"],
    images: { default: image },
    SDG: [1, 2, 3, 11, 12, 13, 14, 15],
    websiteUrl: "projects/tist-farmers-kenya",
    centerCoordinates: {
      lat: -0.034,
      lon: 37.129,
    },
    zoomLevel: 4,
    outcomes: {
      v2: [
        {
          unit: "m2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "Tonnes CO2",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
      v3: [
        {
          unit: "m2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "Tonnes CO2",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
    },
    interventions: [
      {
        action: [],
        ecosystem: ["Desert"],
      },
    ],
  },
  {
    id: "64de0855f189da00ac141992",
    name: "Agroforestry, Upper Tana",
    description:
      "A chance to support local farmers in Kenya at the beginning of their tree planting journey under the TIST program.",
    country: ["GB"],
    images: { default: image },
    SDG: [1, 2, 3, 11, 12, 13, 14, 15, 16],
    websiteUrl: "",
    centerCoordinates: {
      lat: -0.683333,
      lon: 37.15,
    },
    zoomLevel: 4,
    outcomes: {
      v2: [
        {
          unit: "m2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "Tonnes CO2",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
      v3: [
        {
          unit: "m2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "Tonnes CO2",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
    },
    interventions: [
      {
        action: [],
        ecosystem: ["Freshwater"],
      },
    ],
  },
  {
    id: "646bcb4872411e0056166399",
    name: "Bosques Sostenibles - Valle Iruelas",
    description: "TEST",
    country: ["KE"],
    images: {
      default:
        "https://storage.googleapis.com/production-earthly-org-project-images/not-found.png",
    },
    SDG: [1, 2, 3, 11, 12, 13, 14, 15, 16],
    websiteUrl: "",
    centerCoordinates: {
      lat: 40.401,
      lon: -4.5818,
    },
    zoomLevel: 4,
    outcomes: {
      v2: [
        {
          unit: "m2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "Tonnes CO2",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
      v3: [
        {
          unit: "m2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "Tonnes CO2",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
    },
    interventions: [
      {
        action: [],
        ecosystem: ["Forests"],
      },
    ],
  },
  {
    id: "646bc81aab3c9d0066abf668",
    name: "Brazil Nut Concessions in Madre de dios",
    description: "TEST",
    country: ["KE"],
    images: { default: image },
    SDG: [1, 2, 3, 11, 12, 13, 14, 15, 16],
    websiteUrl: "",
    centerCoordinates: {
      lat: -11.07,
      lon: -70.05,
    },
    zoomLevel: 4,
    outcomes: {
      v2: [
        {
          unit: "m2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "Tonnes CO2",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
      v3: [
        {
          unit: "m2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "Tonnes CO2",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
    },
    interventions: [
      {
        action: [],
        ecosystem: ["Coastal"],
      },
    ],
  },
  {
    id: "646bc8faab3c9d0066abf669",
    name: "Charlotte's Wood",
    description: "TEST",
    country: ["KE"],
    images: { default: image },
    SDG: [1, 2, 3, 11, 12, 13, 14, 15, 16],
    websiteUrl: "",
    centerCoordinates: {
      lat: 51.24,
      lon: -2.765,
    },
    zoomLevel: 4,
    outcomes: {
      v2: [
        {
          unit: "Tonnes CO2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "m3 kelp",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
      v3: [
        {
          unit: "Tonnes CO2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "m3 kelp",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
    },
    interventions: [
      {
        action: [],
        ecosystem: ["Marine"],
      },
    ],
  },
  {
    id: "646bca2d72411e0056166397",
    name: "Culm Moor Woodland Reserve",
    description:
      "Culm Moor Nature Reserve shows what Creating Tomorrow's Forests are all about - using their expertise to create diverse, native, thriving woodland as a home for UK wildlife with benefits for people. In this case, a beautiful woodland is being developed on an unused dairy farm located within the North Devon Biosphere Reserve. The woodland will connect into existing woodland fragments to create a contiguous native broadleaved forest where the veteran trees will nurture the growing saplings. The habitat is perfect to carve a space for local birds, pollinators, mammals, lichen and moss communities",
    country: ["KE"],
    images: { default: image },
    SDG: [1, 2, 3, 11, 12, 13, 14, 15, 16],
    websiteUrl: "",
    centerCoordinates: {
      lat: 50.69,
      lon: -4.0691,
    },
    zoomLevel: 4,
    outcomes: {
      v2: [
        {
          unit: "Tonnes CO2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "m2",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
      v3: [
        {
          unit: "Tonnes CO2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "m2",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
    },
    interventions: [
      {
        action: [],
        ecosystem: ["Peatland"],
      },
    ],
  },
  {
    id: "646515bcdd15c50018d38494",
    name: "Degraded Forest Restoration, Mijares",
    description: "TEST",
    country: ["KE"],
    images: { default: image },
    SDG: [1, 2, 3, 11, 12, 13, 14, 15, 16],
    websiteUrl: "",
    centerCoordinates: {
      lat: 40.29,
      lon: -4.83,
    },
    zoomLevel: 4,
    outcomes: {
      v2: [
        {
          unit: "Tonnes CO2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "m2",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
      v3: [
        {
          unit: "Tonnes CO2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "m2",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
    },
    interventions: [
      {
        action: [],
        ecosystem: ["Grassland"],
      },
    ],
  },
  {
    id: "64de0865f189da00ac141993",
    name: "Forest Adaptation- Luckaitz Valley",
    description: "TEST",
    country: ["KE"],
    images: { default: image },
    SDG: [1, 2, 3, 11, 12, 13, 14, 15, 16],
    websiteUrl: "",
    centerCoordinates: {
      lat: 40.29,
      lon: -4.83,
    },
    zoomLevel: 4,
    outcomes: {
      v2: [
        {
          unit: "Tonnes CO2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "m2",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
      v3: [
        {
          unit: "Tonnes CO2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "m2",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
    },
    interventions: [
      {
        action: [],
        ecosystem: ["Farmland"],
      },
    ],
  },
  {
    id: "64a6c050886dad00420d19db",
    name: "Forest Protection, Manoa Farm",
    description:
      "The Manoa REDD+ Project is a groundbreaking project spanning an impressive 74,038.7 hectares in Brazil. The project has garnered global recognition for its exceptional forest management practices and commitment to nature conservation over nearly 30 years. The project encompasses several crucial actions to achieve its ambitious goals to prevent deforestation in a rapidly declining region in the Amazon such as forest patrolling, satellite surveillance for illegal logging, facilitating training programs for local skill development etc thus contributing to the region's overall progress. Altogether, the project avoids 279,290 tons of CO2e emissions per year, equating to 8,378,697 tons of CO2e over the 30-year project duration.",
    country: ["KE"],
    images: { default: image },
    SDG: [1, 2, 3, 11, 12, 13, 14, 15, 16],
    websiteUrl: "",
    centerCoordinates: {
      lat: 40.29,
      lon: -4.83,
    },
    zoomLevel: 4,
    outcomes: {
      v2: [
        {
          unit: "Tonnes CO2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "m2",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
      v3: [
        {
          unit: "Tonnes CO2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "m2",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
    },
    interventions: [
      {
        action: [],
        ecosystem: ["Desert"],
      },
    ],
  },
  {
    id: "64de08784d2c7a00463cfa2d",
    name: "Forest Restoration, Chiapas and Oaxaca",
    description: "TEST",
    country: ["KE"],
    images: { default: image },
    SDG: [1, 2, 3, 11, 12, 13, 14, 15, 16],
    websiteUrl: "",
    centerCoordinates: {
      lat: 40.29,
      lon: -4.83,
    },
    zoomLevel: 4,
    outcomes: {
      v2: [
        {
          unit: "Tonnes CO2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "m2",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
      v3: [
        {
          unit: "Tonnes CO2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "m2",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
    },
    interventions: [
      {
        action: [],
        ecosystem: ["Freshwater"],
      },
    ],
  },
  {
    id: "64de08854d2c7a00463cfa2e",
    name: "Forest Trends - One Million Trees ProjectAgroforestrySmallholderFarmers,ChiapasandOaxaca",
    description: "TEST",
    country: ["KE"],
    images: { default: image },
    SDG: [1, 2, 3, 11, 12, 13, 14, 15, 16],
    websiteUrl: "",
    centerCoordinates: {
      lat: 40.29,
      lon: -4.83,
    },
    zoomLevel: 4,
    outcomes: {
      v2: [
        {
          unit: "Tonnes CO2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "m2",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
      v3: [
        {
          unit: "Tonnes CO2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "m2",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
    },
    interventions: [
      {
        action: [],
        ecosystem: [],
      },
    ],
  },
  {
    id: "64ef7a2b53303e0018d57861",
    name: "Highland Restoration - Northern Ethiopia",
    description: "TEST",
    country: ["KE"],
    images: { default: image },
    SDG: [1, 2, 3, 11, 12, 13, 14, 15, 16],
    websiteUrl: "",
    centerCoordinates: {
      lat: 14.25,
      lon: 38.85,
    },
    zoomLevel: 4,
    outcomes: {
      v2: [
        {
          unit: "Tonnes CO2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "m2",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
      v3: [
        {
          unit: "Tonnes CO2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "m2",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
    },
    interventions: [
      {
        action: [],
        ecosystem: [],
      },
    ],
  },
  {
    id: "6658829979e3b70018d41f5f",
    name: "Iford Estate Woodland Creation",
    description: "TEST",
    country: ["KE"],
    images: { default: image },
    SDG: [1, 2, 3, 11, 12, 13, 14, 15, 16],
    websiteUrl: "",
    centerCoordinates: {
      lat: 50.887255,
      lon: -0.033615,
    },
    zoomLevel: 4,
    outcomes: {
      v2: [
        {
          unit: "Tonnes CO2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "m2",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
      v3: [
        {
          unit: "Tonnes CO2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "m2",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
    },
    interventions: [
      {
        action: [],
        ecosystem: [],
      },
    ],
  },
  {
    id: "6464a0b71fb8a100753ffa97",
    name: "Kasigau Corridor REDD+ Project",
    description: "TEST",
    country: ["KE"],
    images: { default: image },
    SDG: [1, 2, 3, 11, 12, 13, 14, 15, 16],
    websiteUrl: "",
    centerCoordinates: {
      lat: -3.707356,
      lon: 38.754959,
    },
    zoomLevel: 4,
    outcomes: {
      v2: [
        {
          unit: "m3 kelp",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "m2",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
      v3: [
        {
          unit: "m3 kelp",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "m2",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
    },
    interventions: [
      {
        action: [],
        ecosystem: ["random"],
      },
    ],
  },
  {
    id: "64650b5a92f304001139ec1c",
    name: "Mai Ndombe",
    description: "TEST",
    country: ["KE"],
    images: { default: image },
    SDG: [1, 2, 3, 11, 12, 13, 14, 15, 16],
    websiteUrl: "",
    centerCoordinates: {
      lat: -2.565,
      lon: 16.21,
    },
    zoomLevel: 4,
    outcomes: {
      v2: [
        {
          unit: "Tonnes CO2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "m2",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
      v3: [
        {
          unit: "Tonnes CO2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "m2",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
    },
    interventions: [
      {
        action: [],
        ecosystem: [],
      },
    ],
  },
  {
    id: "6438298b4630d90019a44345",
    name: "Mangrove Planting, Maroalika",
    description: "TEST",
    country: ["KE"],
    images: { default: image },
    SDG: [1, 2, 3, 11, 12, 13, 14, 15, 16],
    websiteUrl: "",
    centerCoordinates: {
      lat: -16,
      lon: 45.15,
    },
    zoomLevel: 4,
    outcomes: {
      v2: [
        {
          unit: "Tonnes CO2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "m2",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
      v3: [
        {
          unit: "Tonnes CO2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "m2",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
    },
    interventions: [
      {
        action: [],
        ecosystem: ["Marine"],
      },
    ],
  },
  {
    id: "64650eb7dd15c50018d3848f",
    name: "Mangrove Restoration Pakistan",
    description: "TEST",
    country: ["KE"],
    images: { default: image },
    SDG: [1, 2, 3, 11, 12, 13, 14, 15, 16],
    websiteUrl: "Coastal",
    centerCoordinates: {
      lat: 24.6,
      lon: 68.07,
    },
    zoomLevel: 4,
    outcomes: {
      v2: [
        {
          unit: "Tonnes CO2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "m2",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
      v3: [
        {
          unit: "Tonnes CO2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "m2",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
    },
    interventions: [
      {
        action: [],
        ecosystem: ["Peatland"],
      },
    ],
  },
  {
    id: "66696e6e8ac35300117c5aa9",
    name: "Native Woodland Restoration - Sofala, Mozambique",
    description:
      "The Kukumuty project in Mozambique aims to restore around 400 hectares (in the first instance) of Miombo woodland near Chibabava, as well as establish agroforestry nurseries and systems in the area. The Miombo woodlands are a tropical woodland system that cover 10% of Africa and are increasingly endangered due to rapid climatic changes and increased economic pressure. By restoring this crucial ecosystem, and developing agroforestry systems to reduce pressure on the native woodland, the Kukumuty project will effectively conserve and restore one of Africa's most magnificent ecosystems. ",
    country: ["KE"],
    images: { default: image },
    SDG: [1, 2, 3, 11, 12, 13, 14, 15, 16],
    websiteUrl: "",
    centerCoordinates: {
      lat: -20.29282,
      lon: 33.65516,
    },
    zoomLevel: 4,
    outcomes: {
      v2: [
        {
          unit: "Tonnes CO2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "m2",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
      v3: [
        {
          unit: "Tonnes CO2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "m2",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
    },
    interventions: [
      {
        action: [],
        ecosystem: ["Grassland"],
      },
    ],
  },
  {
    id: "6464b6ec1fb8a100753ffa9b",
    name: "Peatland Protection & Restoration, Sumatra-Merang",
    description:
      "The Kukumuty project in Mozambique aims to restore around 400 hectares (in the first instance) of Miombo woodland near Chibabava, as well as establish agroforestry nurseries and systems in the area. The Miombo woodlands are a tropical woodland system that cover 10% of Africa and are increasingly endangered due to rapid climatic changes and increased economic pressure. By restoring this crucial ecosystem, and developing agroforestry systems to reduce pressure on the native woodland, the Kukumuty project will effectively conserve and restore one of Africa's most magnificent ecosystems. ",
    country: ["KE", "MX"],
    images: { default: image },
    SDG: [1, 2, 3, 11, 12, 13, 14, 15, 16],
    websiteUrl: "",
    centerCoordinates: {
      lat: -2.220571,
      lon: 104.467444,
    },
    zoomLevel: 4,
    outcomes: {
      v2: [
        {
          unit: "Tonnes CO2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "m2",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
      v3: [
        {
          unit: "Tonnes CO2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "m2",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
    },
    interventions: [
      {
        action: [],
        ecosystem: ["Desert"],
      },
    ],
  },
  {
    id: "646bcac372411e0056166398",
    name: "Planting Mangroves in Madagascar - Ankilahila",
    description:
      "The Kukumuty project in Mozambique aims to restore around 400 hectares (in the first instance) of Miombo woodland near Chibabava, as well as establish agroforestry nurseries and systems in the area. The Miombo woodlands are a tropical woodland system that cover 10% of Africa and are increasingly endangered due to rapid climatic changes and increased economic pressure. By restoring this crucial ecosystem, and developing agroforestry systems to reduce pressure on the native woodland, the Kukumuty project will effectively conserve and restore one of Africa's most magnificent ecosystems. ",
    country: ["KE"],
    images: { default: image },
    SDG: [1, 2, 3, 11, 12, 13, 14, 15, 16],
    websiteUrl: "",
    centerCoordinates: {
      lat: -15.579,
      lon: 46.497,
    },
    zoomLevel: 4,
    outcomes: {
      v2: [
        {
          unit: "Tonnes CO2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "m2",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
      v3: [
        {
          unit: "Tonnes CO2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "m2",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
    },
    interventions: [
      {
        action: [],
        ecosystem: ["Freshwater"],
      },
    ],
  },
  {
    id: "666961a17330430018ee83de",
    name: "Regenerative Farming - Indo-Gangetic Plains, India",
    description:
      "The project accelerates the adoption of sustainable agricultural practices to cut greenhouse gas emissions, restore degraded land, and boost soil health and crop yields. Using regenerative techniques like reduced tillage, Direct Seeding of Rice (DSR), crop residue management, crop rotation, and cover crops, it replaces harmful traditional methods. Launched in June 2019 in Punjab and Haryana, it now extends to maize-wheat, sugarcane, and cotton systems, incorporating pulses and mustards as cover crops. Over 51,000 farmers across 600,000 acres in 7 Indian states are already a part of the project. This initiative stands out for its contribution to the 12 Sustainable Development Goals, making a significant stride towards sustainable agriculture with far-reaching impacts on the environment and local livelihoods.",
    country: ["KE"],
    images: { default: image },
    SDG: [1, 2, 3, 11, 12, 13, 14, 15, 16],
    websiteUrl: "",
    centerCoordinates: {
      lat: 26.961246,
      lon: 78.299561,
    },
    zoomLevel: 4,
    outcomes: {
      v2: [
        {
          unit: "Tonnes CO2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "m2",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
      v3: [
        {
          unit: "Tonnes CO2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "m2",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
    },
    interventions: [
      {
        action: [],
        ecosystem: ["SkippedyBooba"],
      },
    ],
  },
  {
    id: "6464b4dca3776e0065d02e30",
    name: "Rimba Raya",
    description:
      "The project accelerates the adoption of sustainable agricultural practices to cut greenhouse gas emissions, restore degraded land, and boost soil health and crop yields. Using regenerative techniques like reduced tillage, Direct Seeding of Rice (DSR), crop residue management, crop rotation, and cover crops, it replaces harmful traditional methods. Launched in June 2019 in Punjab and Haryana, it now extends to maize-wheat, sugarcane, and cotton systems, incorporating pulses and mustards as cover crops. Over 51,000 farmers across 600,000 acres in 7 Indian states are already a part of the project. This initiative stands out for its contribution to the 12 Sustainable Development Goals, making a significant stride towards sustainable agriculture with far-reaching impacts on the environment and local livelihoods.",
    country: ["KE"],
    images: { default: image },
    SDG: [1, 2, 3, 11, 12, 13, 14, 15, 16],
    websiteUrl: "",
    centerCoordinates: {
      lat: -3.055312,
      lon: 112.15356,
    },
    zoomLevel: 4,
    outcomes: {
      v2: [
        {
          unit: "Tonnes CO2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "m2",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
      v3: [
        {
          unit: "Tonnes CO2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "m2",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
    },
    interventions: [
      {
        action: [],
        ecosystem: ["Coastal"],
      },
    ],
  },
  {
    id: "6464aa0fa3776e0065d02e2f",
    name: "Seaweed Farming Innovation, Cornwall",
    description:
      "The project accelerates the adoption of sustainable agricultural practices to cut greenhouse gas emissions, restore degraded land, and boost soil health and crop yields. Using regenerative techniques like reduced tillage, Direct Seeding of Rice (DSR), crop residue management, crop rotation, and cover crops, it replaces harmful traditional methods. Launched in June 2019 in Punjab and Haryana, it now extends to maize-wheat, sugarcane, and cotton systems, incorporating pulses and mustards as cover crops. Over 51,000 farmers across 600,000 acres in 7 Indian states are already a part of the project. This initiative stands out for its contribution to the 12 Sustainable Development Goals, making a significant stride towards sustainable agriculture with far-reaching impacts on the environment and local livelihoods.",
    country: ["KE"],
    images: { default: image },
    SDG: [1, 2, 3, 11, 12, 13, 14, 15, 16],
    websiteUrl: "",
    centerCoordinates: {
      lat: 50.414804,
      lon: -3.722571,
    },
    zoomLevel: 4,
    outcomes: {
      v2: [
        {
          unit: "Tonnes CO2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "m2",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
      v3: [
        {
          unit: "Tonnes CO2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "m2",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
    },
    interventions: [
      {
        action: [],
        ecosystem: ["Forests"],
      },
    ],
  },
  {
    id: "64de08a64d2c7a00463cfa30",
    name: "Tree Plantation, Usambara Mountains",
    description: "The project...",
    country: ["KE"],
    images: { default: image },
    SDG: [1, 2, 3, 11, 12, 13, 14, 15, 16],
    websiteUrl: "",
    centerCoordinates: {
      lat: 50.414804,
      lon: -3.722571,
    },
    zoomLevel: 4,
    outcomes: {
      v2: [
        {
          unit: "Tonnes CO2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "m2",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
      v3: [
        {
          unit: "Tonnes CO2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "m2",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
    },
    interventions: [
      {
        action: [],
        ecosystem: ["Marine"],
      },
    ],
  },
  {
    id: "64651378dd15c50018d38493",
    name: "Tree Planting- TIST Kenya",
    description: "The project...",
    country: ["KE"],
    images: { default: image },
    SDG: [1, 2, 3, 11, 12, 13, 14, 15, 16],
    websiteUrl: "",
    centerCoordinates: {
      lat: -0.034,
      lon: 37.129,
    },
    zoomLevel: 4,
    outcomes: {
      v2: [
        {
          unit: "Tonnes CO2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "m2",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
      v3: [
        {
          unit: "Tonnes CO2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "m2",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
    },
    interventions: [
      {
        action: [],
        ecosystem: ["Peatland"],
      },
    ],
  },
  {
    id: "65afa75d40b5cb00125ddc7d",
    name: "Tree Sponsorship, Central Scotland",
    description: "The project...",
    country: ["KE"],
    images: { default: image },
    SDG: [1, 2, 3, 11, 12, 13, 14, 15, 16],
    websiteUrl: "",
    centerCoordinates: {
      lat: 56.14904,
      lon: -3.858,
    },
    zoomLevel: 4,
    outcomes: {
      v2: [
        {
          unit: "Tonnes CO2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "m2",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
      v3: [
        {
          unit: "Tonnes CO2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "m2",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
    },
    interventions: [
      {
        action: [],
        ecosystem: ["Farmland"],
      },
    ],
  },
  {
    id: "64649cfea3776e0065d02e2c",
    name: "Tropical Forest Protection, Keo Seima",
    description: "The project...",
    country: ["KE"],
    images: { default: image },
    SDG: [1, 2, 3, 11, 12, 13, 14, 15, 16],
    websiteUrl: "",
    centerCoordinates: {
      lat: 12.335594,
      lon: 106.841901,
    },
    zoomLevel: 4,
    outcomes: {
      v2: [
        {
          unit: "Tonnes CO2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "m2",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
      v3: [
        {
          unit: "Tonnes CO2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "m2",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
    },
    interventions: [
      {
        action: [],
        ecosystem: ["Desert"],
      },
    ],
  },
  {
    id: "65afa5c92a9488001944c14b",
    name: "Biodiversity? Let's pretend this is",
    description: "The project...",
    country: ["KE"],
    images: { default: image },
    SDG: [1, 2, 3, 11, 12, 13, 14, 15, 16],
    websiteUrl: "",
    centerCoordinates: {
      lat: 50.880131,
      lon: -0.033152103,
    },
    zoomLevel: 4,
    outcomes: {
      v2: [
        {
          unit: "Tonnes CO2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "m2",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
      v3: [
        {
          unit: "Tonnes CO2",
          value: 5,
          isUnitOfSale: false,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
        {
          unit: "m2",
          value: 12,
          isUnitOfSale: true,
          startDate: 0,
          endDate: 1234567891234,
          updatedAt: 1212121212121,
          author: "me@earthly.org",
        },
      ],
    },
    interventions: [
      {
        action: [],
        ecosystem: ["Freshwater"],
      },
    ],
    unitData: {
      geometry: {
        type: "FeatureCollection",
        features: [
          {
            type: "Feature",
            geometry: {
              type: "MultiPolygon",
              coordinates: [
                [
                  [
                    [55.9, 69.9],
                    [55.9, 70.1],
                    [56.1, 70.1],
                    [56.1, 69.9],
                    [55.9, 69.9],
                  ],
                ],
              ],
            },
          },
        ],
      },
      unitCount: 1,
      clientUnitTotalArea: 9,
    },
  },
];

export default mockProjects;
